import type { Tier } from '../hooks/use-pricing-table';

function validateBounds(tiers: Tier[]): string[] {
  const errs: string[] = [];
  const first = tiers[0];
  const last = tiers[tiers.length - 1];
  if (first && first.min !== 1) errs.push('Primer tramo debe empezar en 1');
  if (last && last.max !== null) errs.push('Último tramo debe ser abierto');
  return errs;
}

function validateGaps(tiers: Tier[]): string[] {
  const errs: string[] = [];
  for (let i = 1; i < tiers.length; i++) {
    const prev = tiers[i - 1];
    const curr = tiers[i];
    if (prev && curr && curr.min !== (prev.max ?? 0) + 1)
      errs.push(`Gap entre tramos ${i} y ${i + 1}`);
  }
  return errs;
}

function validatePrices(tiers: Tier[]): string[] {
  return tiers
    .filter((t) => t.price_per_lead <= 0)
    .map((_, i) => `Tramo ${i + 1}: precio > 0`);
}

export function validateTiers(tiers: Tier[]): string[] {
  if (!tiers.length) return ['Debe haber al menos un tramo'];
  return [
    ...validateBounds(tiers),
    ...validateGaps(tiers),
    ...validatePrices(tiers),
  ];
}
